import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UpdateUserModel } from '../models/update-user-model';
import { ClassLiteResponseModel } from '../models/class-lite-response-model';
import { SchoolLiteResponseModel } from '../models/school-lite-response-model';
import { IUniversalScreenerStatusModel } from '../models/universal-screener-model';
import { HttpContext } from '@angular/common/http';
import { PostResponse } from '../studio-http-client/post-response';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { TextToSpeechType } from '../enums/text-to-speech-type.enum';
import { ReadingScreeningType } from '../enums/reading-screening-type.enum';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiService = inject(ApiService);

  updateUser(userId: number, request: UpdateUserModel) {
    const url = `v1/internal/users/${userId}`;
    return this.apiService.invokeMPApi<PostResponse>(url, HttpAction.Put, request);
  }

  updatePassword(userId: number, currentPassword: string, newPassword: string) {
    const url = `v1/internal/users/${userId}/password`;
    return this.apiService.invokeMPApi<PostResponse>(url, HttpAction.Put, {
      currentPassword,
      newPassword,
    });
  }

  getUniversalScreenerStatus(userId: number) {
    const url = `v1/internal/students/${userId}/UniversalScreenerStatus`;
    return this.apiService.invokeMPApi<IUniversalScreenerStatusModel>(url, HttpAction.Get);
  }

  getScreenerStatus() {
    const url = `v1/internal/progressMaps/screenerStatus/Me`;
    return this.apiService.invokeMPApi<{
      isScreenerRequired: boolean;
      screeningType: ReadingScreeningType;
    }>(url, HttpAction.Get);
  }

  getSchoolsLiteByCustomerId(customerId: number) {
    const url = `v1/internal/districts/${customerId}/schoolslite`;
    return this.apiService.invokeMPApi<SchoolLiteResponseModel[]>(url, HttpAction.Get);
  }

  getClassesBySchoolIds(schoolIds: number[]) {
    const url = `v1/internal/classes/GetClassesBySchoolIds`;
    return this.apiService.invokeMPApi<ClassLiteResponseModel[]>(
      url,
      HttpAction.PostWithBodyResponse,
      schoolIds
    );
  }

  getClassesByClassIds(classIds: number[], context: HttpContext = null) {
    const url = `v1/internal/classes/GetClassesByClassIds`;
    return this.apiService.invokeMPApi<ClassLiteResponseModel[]>(
      url,
      HttpAction.PostWithBodyResponse,
      classIds,
      { context }
    );
  }

  postEmailSalesRep() {
    const url = `v1/internal/teachers/EmailSalesRep`;
    return this.apiService.invokeMPApi<PostResponse>(url, HttpAction.Post);
  }

  textToSpeechUsage(
    userId: string,
    type: TextToSpeechType,
    voiceId: string,
    dateTime: string,
    bookId: string,
    characterCount: number
  ) {
    if (bookId && userId) {
      const url = `api/Users/${userId}/TextToSpeechUsages`;
      return this.apiService.invokeLSApi(url, HttpAction.Post, {
        userId,
        type,
        voiceId,
        dateTime,
        bookId,
        characterCount,
      });
    } else {
      return null;
    }
  }
}
